<template>
  <div>
    <b-form-input
      type="text"
      :placeholder="placeholder"
      :readonly="readonly"
      v-model="formattedValue"
      v-mask="'999999999'"
    />
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";

export default {
  name: "BaseInputInteger",
  props: {
    value: Number,
    placeholder: String,
    readonly: Boolean,
  },
  directives: {
    mask: AwesomeMask,
  },
  data() {
    return {
      formattedValue: "",
    };
  },
  created() {
    this.formattedValue = this.doubleToString(this.value);
  },
  computed: {},
  methods: {
    doubleToString(value) {
      let strValue = value.toString();
      if (strValue.indexOf(".") < 0) {
        strValue = value.toFixed(0);
      }
      return strValue;
    },
  },
  watch: {
    formattedValue() {
      let newValue = this.formattedValue
        .replaceAll(".", "")
        .replaceAll(",", ".");
      if (newValue.length == 0) newValue = 0;
      else newValue = parseInt(newValue);
      // this.$emit('update', newValue);
      this.$emit("update:value", newValue);
    },
    value() {
      this.formattedValue = this.doubleToString(this.value);
      this.$forceUpdate();
    },
  },
};
</script>
